import { useEffect, useState, type FC } from "react";
import MainLayout from "../../MainLayout";
import { Button, Modal, SelectPicker } from "rsuite";
import {
  Product,
  ProductRecommendation,
} from "../../../models/inventory/product";
import { getProducts } from "../../../services/inventory/ProductApi";
import CurrencyInput from "react-currency-input-field";

interface ProductRecommendationFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProductRecommendation) => void;
  recommendation?: ProductRecommendation;
}

const ProductRecommendationForm: FC<ProductRecommendationFormProps> = ({
  open,
  onClose,
  onSubmit,
  recommendation,
}) => {
  const [data, setData] = useState<ProductRecommendation>({
    id: "",
    product_id: "",
    score: 0,
  });
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    getProducts({
      page: 1,
      size: 10,
      search: "",
    })
      .then((v) => v.json())
      .then((v) => setProducts(v.data.items));
  }, []);
  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Recommendation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Product</label>
            <div className="input">
              {recommendation?.id ? (
                <div>{recommendation?.product?.name}</div>
              ) : (
                <SelectPicker
                  block
                  data={products}
                  labelKey="name"
                  valueKey="id"
                  value={data.product_id}
                  onChange={(value) => {
                    setData({ ...data, product_id: value! });
                  }}
                  onSearch={(val) => {
                    if (val) {
                      getProducts({
                        page: 1,
                        size: 10,
                        search: val,
                      })
                        .then((v) => v.json())
                        .then((v) => setProducts(v.data.items));
                    }
                  }}
                />
              )}
            </div>
          </div>
          <div className="form-group">
            <label>Score</label>
            <CurrencyInput
              className="rs-input"
              value={data.score}
              groupSeparator="."
              decimalSeparator=","
              onValueChange={(score, name, values) =>
                setData({ ...data, score: values?.float ?? 0 })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                product_id: "",
                score: 0,
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ProductRecommendationForm;
